import {
    Box,
    Button,
    Skeleton,
    Theme,
    Typography
} from "@mui/material";
import { checkImageExists, toINR } from "../../../../utils/utilityFunctions";
import { ColorMap } from "../../types";
import { BlackDownArrowIcon } from "../../../../assets/SvgIcons";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../../redux-store/reducers";

const colorMap: ColorMap = {
    successful: 'success.800',
    "in progress": 'warning.500',
    failed: 'error.500',
    "s": 'success.800',
    "f": 'error.500',
    "p": 'warning.500'
}

const otpStatusMap: Record<string, string> = {
    "s": "Success",
    "f": "Failed",
    "p": "Pending"
}

function ColorCircle(
    { backgroundColor }: { backgroundColor: string }
): JSX.Element {
    return (
        <Box
            sx={{
                width: "11px",
                height: "11px",
                borderRadius: "50%",
                backgroundColor
            }}
        />
    )
}

export default function OrderInfo(
    {
        data,
        handleViewDetailsClick,
        isLoading
    }: any
): JSX.Element {

    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    return (
        <Box>
            <Box
                sx={(theme: Theme) => ({
                    paddingBottom: "15px",
                    borderBottom: `0.5px dashed ${theme.palette.text.secondary}B2`
                })}
            >

                {isLoading ? (
                    <Skeleton variant="text" animation="wave" />

                ) :
                    <Typography
                        variant="body_500"
                        sx={(theme: Theme) => ({
                            color: theme.palette.text.secondary
                        })}
                    >
                        {data.orderDate}
                    </Typography>
                }
            </Box>
            {/* data?.schemes is an array of array */}
            {(data?.schemes ? data?.schemes : [[], []])?.map((arrayObj: Array<any>, key: number) => (


                <Box key={key} sx={(theme: Theme) => ({ borderBottom: `0.5px solid ${theme.palette.text.secondary}B2` })}>
                    {arrayObj?.map((obj: any, key: number) => (
                        <Box
                            key={key}
                            sx={(theme: Theme) => ({
                                padding: "25px 0px",
                                // borderBottom: arrayObj.length - 1 === key ? "0px" : `0.5px dashed ${theme.palette.text.secondary}B2`,
                                display: "flex",
                                columnGap: "5px",
                                alignItems: "center",
                            })}
                        >
                            <Box
                                sx={{
                                    maxWidth: "468px",
                                    flex: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                    rowGap: "15px",
                                    justifyContent: "center"
                                }}
                            >
                                {/* From Scheme Name and Image Start */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        columnGap: "12px",
                                        alignItems: "center",

                                    }}
                                >
                                    {isLoading ? (
                                        <>
                                            <Skeleton variant="rectangular" animation="wave" width={35} height={35} />
                                            <Skeleton variant="text" animation="wave" width={100} />
                                        </>
                                    ) : (
                                        <>
                                            <img
                                                src={checkImageExists(`${obj?.amcId}`) ? `../../../../../../images/amcIcons/${obj?.amcId}.svg` : `../../../../../../images/amcIcons/default.svg`}
                                                alt={obj?.fromSchemeName}
                                                width={35}
                                                height={35}
                                                style={{
                                                    objectFit: "contain",
                                                    borderRadius: "8px"
                                                }}
                                            />
                                            <Typography
                                                variant="body_500"
                                                sx={(theme: Theme) => ({
                                                    color: theme.palette.text.primary,
                                                    '&:hover': {
                                                        color: theme.palette.primary[500],
                                                    },
                                                })}
                                            >
                                                {obj?.fromSchemeName}
                                            </Typography>
                                        </>
                                    )}
                                </Box>
                                {/* From Scheme Name and Image End */}

                                {obj?.toSchemeName && (
                                    isLoading ? <>

                                        <Skeleton variant="rectangular" animation="wave" width={35} height={35} />
                                        <Skeleton variant="text" animation="wave" width={100} />


                                    </> :
                                        <>
                                            <BlackDownArrowIcon />

                                            {/* To Scheme Name and Image Start */}
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    columnGap: "12px",
                                                    alignItems: "center",
                                                    maxWidth: "468px",
                                                    flex: 1
                                                }}
                                            >

                                                <img
                                                    src={checkImageExists(`${obj?.amcId}`) ? `../../../../../../images/amcIcons/${obj?.amcId}.svg` : `../../../../../../images/amcIcons/default.svg`}
                                                    alt={obj?.toSchemeName}
                                                    width={35}
                                                    height={35}
                                                    style={{
                                                        objectFit: "contain",
                                                        borderRadius: "8px"
                                                    }}
                                                />
                                                <Typography
                                                    variant="body_500"
                                                    sx={(theme: Theme) => ({
                                                        color: theme.palette.text.primary,
                                                        '&:hover': {
                                                            color: theme.palette.primary[500],
                                                        },
                                                    })}
                                                >
                                                    {obj?.toSchemeName}
                                                </Typography>
                                            </Box>
                                        </>
                                )


                                    // To Scheme Name and Image End
                                }
                            </Box>

                            {/* Purchase Type Start */}
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    rowGap: "3px",
                                    maxWidth: "240px",
                                    flex: 1
                                }}
                            >
                                {isLoading ?
                                    (
                                        <>
                                            <Skeleton variant="text" animation="wave" width={'100%'} />
                                            <Skeleton variant="text" animation="wave" width={'100%'} />
                                        </>
                                    ) :
                                    (
                                        <>
                                            <Typography
                                                variant="body_500"
                                                sx={(theme: Theme) => ({
                                                    color: theme.palette.text.secondary
                                                })}
                                            >
                                                Purchase Type
                                            </Typography>
                                            <Typography
                                                variant="body_500"
                                                sx={(theme: Theme) => ({
                                                    fontWeight: 600,
                                                    color: theme.palette.text.primary
                                                })}
                                            >
                                                {obj.purchaseType}
                                            </Typography>
                                        </>
                                    )
                                }
                            </Box>
                            {/* Purchase Type End */}

                            {/* Amount Type Start */}
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    rowGap: "3px",
                                    maxWidth: "176px",
                                    flex: 1
                                }}
                            >
                                {isLoading ? (
                                    <>
                                        <Skeleton variant="text" animation="wave" width={'100%'} />
                                        <Skeleton variant="text" animation="wave" width={'100%'} />
                                    </>
                                ) : (
                                    <>
                                        <Typography
                                            variant="body_500"
                                            sx={(theme: Theme) => ({
                                                color: theme.palette.text.secondary
                                            })}
                                        >
                                            Amount
                                        </Typography>
                                        <Typography
                                            variant="body_500"
                                            sx={(theme: Theme) => ({
                                                fontWeight: 600,
                                                color: theme.palette.text.primary
                                            })}
                                        >
                                            {obj.amount ? toINR({ value: obj.amount, locale, currencyCode }) : "-"}
                                        </Typography>
                                    </>
                                )}
                            </Box>
                            {/* Amount Type End */}

                            {/* Units Type Start */}
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    rowGap: "3px",
                                    maxWidth: "176px",
                                    flex: 1
                                }}
                            >
                                {isLoading ? (
                                    <>
                                        <Skeleton variant="text" animation="wave" width={'100%'} />
                                        <Skeleton variant="text" animation="wave" width={'100%'} />
                                    </>
                                ) : (
                                    <>
                                        <Typography
                                            variant="body_500"
                                            sx={(theme: Theme) => ({
                                                color: theme.palette.text.secondary
                                            })}
                                        >
                                            Units
                                        </Typography>
                                        <Typography
                                            variant="body_500"
                                            sx={(theme: Theme) => ({
                                                fontWeight: 600,
                                                color: theme.palette.text.primary
                                            })}
                                        >
                                            {obj?.units ? Number(obj?.units ?? 0).toFixed(4) : "-"}
                                        </Typography>
                                    </>
                                )}
                            </Box>
                            {/* Units Type End */}

                            {/* OTP Status Start */}
                            <Box
                                sx={{
                                    maxWidth: "176px",
                                    flex: 1,
                                    display: "flex",
                                    columnGap: "15px",
                                    alignItems: "flex-start",
                                    flexDirection: "column",
                                    rowGap: "3px",
                                }}
                            >
                                {isLoading ? (
                                    <>
                                        <Skeleton variant="rounded" animation="wave" width={12} height={12} />
                                        <Skeleton variant="text" animation="wave" width={'100%'} />
                                    </>
                                ) :
                                    (
                                        <>
                                            <Typography
                                                variant="body_500"
                                                sx={(theme: Theme) => ({
                                                    color: theme.palette.text.secondary
                                                })}
                                            >
                                                OTP Status
                                            </Typography>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                <ColorCircle
                                                    backgroundColor={colorMap[`${obj.isOTPVerified || "F"}`.toLowerCase()]}
                                                />
                                                <Typography
                                                    variant="body_500"
                                                    sx={(theme: Theme) => ({
                                                        fontWeight: 600,
                                                        color: theme.palette.text.primary
                                                    })}
                                                >
                                                    {otpStatusMap[`${obj?.isOTPVerified || "F"}`.toLowerCase()]}
                                                </Typography>
                                            </Box>
                                        </>
                                    )
                                }
                            </Box>
                            {/* OTP Status End */}

                            {/* Status Start */}
                            < Box
                                sx={{
                                    maxWidth: "176px",
                                    flex: 1,
                                    display: "flex",
                                    columnGap: "15px",
                                    alignItems: "flex-start",
                                    flexDirection: "column",
                                    rowGap: "3px",
                                }}
                            >
                                {/* {obj.status === "success" && (
                        <> */}
                                {isLoading ? (
                                    <>
                                        <Skeleton variant="rounded" animation="wave" width={12} height={12} />
                                        <Skeleton variant="text" animation="wave" width={'100%'} />
                                    </>
                                ) :
                                    (
                                        <>
                                            <Typography
                                                variant="body_500"
                                                sx={(theme: Theme) => ({
                                                    color: theme.palette.text.secondary
                                                })}
                                            >
                                                Status
                                            </Typography>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                <ColorCircle
                                                    backgroundColor={colorMap[`${obj.status || "Failed"}`.toLowerCase()]}
                                                />
                                                <Typography
                                                    variant="body_500"
                                                    sx={(theme: Theme) => ({
                                                        fontWeight: 600,
                                                        color: theme.palette.text.primary
                                                    })}
                                                >
                                                    {obj?.status || "Failed"}
                                                </Typography>
                                            </Box>
                                        </>
                                    )
                                }
                                {/* </>
                    )} */}
                                {/* {obj.status === "inprogress" && (
                        <>
                            <ColorCircle
                                backgroundColor={colorMap["In-Progress"]}
                            />
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary
                                })}
                            >
                                In-Progress
                            </Typography>
                        </>
                    )}
                    {obj.status === "fail" && (
                        <>
                            <ColorCircle
                                backgroundColor={colorMap["Failed"]}
                            />
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary
                                })}
                            >
                                Failed
                            </Typography>
                        </>
                    )} */}
                            </Box>
                            {/* Status End */}

                            {/* View Details Button Start */}
                            <Box>
                                {isLoading ?
                                    <Skeleton variant="rounded" animation="wave" width={100} height={50} /> :
                                    <Button
                                        variant="outlined"
                                        sx={(theme: Theme) => ({
                                            color: theme.palette.primary[500],
                                            border: `1px solid ${theme.palette.primary[500]}`,
                                            borderRadius: "4px",
                                            padding: "7px",
                                            ...theme.typography.body_500
                                        })}
                                        onClick={() => handleViewDetailsClick(data.orderId, obj.schemeId, obj?.transNo, obj?.id)}
                                    >
                                        View Details
                                    </Button>

                                }
                            </Box>
                            {/* View Details Button End */}
                        </Box>
                    ))}
                </Box>

            ))}
        </Box>
    )
}